/*
 * DesertLandscaping.Router 
 */
/* eslint no-use-before-define: 0 */
import { App } from './desertland.app';
import { Utils } from './cals.utils';
import 'kendo-ui-core';
// import 'kendo-ui-core/js/kendo.router';

declare var log, info, warn, groupCollapsed, groupEnd;

export const ROUTES = {
  HOME: "index",
  ABOUT: "about",
  CONTACT: "contact",
  IDEAS: "design-ideas",
  PLANT: "plant",
  PLANTS: "plants",
  LEARN: "learn-more",
  TIPS: "desert-gardening",
  TRIVIA: "trivia",
  RESOURCES: "resources",
  BIBLIOGRAPHY: "bibliography",
  HISTORY: "history",
  ACKNOWLEDGE: "acknowledgements",
};

export class Router {

  private skipRoute: boolean = false;

  public start() {

    let me = this;
    let router = new kendo.Router({
      routeMissing(e) {
        info('route missing', e.url);
        //Controller.home();
      },
      change(e) {
        groupCollapsed("Router");
        log('router change', e.url, e);
        let params = Utils.getURLParamsObj();
        info('params', params);
        if (e && params && (!e.params || Utils.isEmpty(e.params))) {
          e.params = params;
        }
        App.shareUrl = "";//resetit
        me.skipRoute = handleRouteParams(e);
        // if (DESERTLAND.Content && DESERTLAND.Content.Tips && DESERTLAND.Content.Tips.onClickTipsTopNav) {
        //     info("unsubscribe: " + 'topnav:click:tips');
        //     DESERTLAND.radio('topnav:click:tips').unsubscribe(DESERTLAND.Content.Tips.onClickTipsTopNav);
        // }
      }
    });

    router.bind("init", function (e) {
      // log("Router.init", e);
      if (e && e.url) {
        if (e.url.indexOf('.') === 0) {
          info("addThis'd - there's a tracking hash, remove it");
          e.url = '/';
        }
      }
      me.skipRoute = false;
    });

    router.route("/" + ROUTES.PLANTS + "(/*suffix)", function (suffix, params) {
      log("route: plants/*=", suffix);
      if (!me.skipRoute) {
        App.controller.plants(suffix);
      }
    });

    router.route("/" + ROUTES.PLANT + "(/:id)(/:name)(/*suffix)", function (id, name, suffix, params) {
      log("route: /plant/", id, name, suffix);
      if (!me.skipRoute) {
        App.controller.plant(id, name, suffix);
      }
    });

    router.route("/" + ROUTES.TIPS + "(/*suffix)", function (suffix, params) {
      log("route: /tips/*=", suffix);
      if (!me.skipRoute) {
        App.controller.tips(suffix);
      }
    });

    router.route("/" + ROUTES.IDEAS + "(/*suffix)", function (suffix, params) {
      log("route: /ideas/*=", suffix);
      if (!me.skipRoute) {
        App.controller.ideas(suffix);
      }
    });

    router.route("/" + ROUTES.TRIVIA + "(/*suffix)", function (suffix, params) {
      log("route: /trivia/*=", suffix);
      if (!me.skipRoute) {
        App.controller.trivia(suffix);
      }
    });

    router.route("/" + ROUTES.RESOURCES + "(/*suffix)", function (suffix, params) {
      log("route: /resources/*=", suffix);
      if (!me.skipRoute) {
        App.controller.resources(suffix);
      }
    });

    // added 11-2018
    router.route("/" + ROUTES.BIBLIOGRAPHY + "(/*suffix)", function (suffix, params) {
      log("route: /bibliography/*=", suffix);
      if (!me.skipRoute) {
        App.controller.bibliography(suffix);
      }
    });
    router.route("/" + ROUTES.HISTORY + "(/*suffix)", function (suffix, params) {
      log("route: /history/*=", suffix);
      if (!me.skipRoute) {
        App.controller.history(suffix);
      }
    });
    router.route("/" + ROUTES.ACKNOWLEDGE + "(/*suffix)", function (suffix, params) {
      log("route: /acknowledgements/*=", suffix);
      if (!me.skipRoute) {
        App.controller.acknowledge(suffix);
      }
    });


    router.route("/" + ROUTES.ABOUT + "(/*suffix)", function (suffix, params) {
      log("route: /about/*=", suffix);
      if (!me.skipRoute) {
        App.controller.about(suffix);
      }
    });

    router.route("/" + ROUTES.LEARN + "(/*suffix)", function (suffix, params) {
      log("route: /learn-more/*=", suffix);
      if (!me.skipRoute) {
        App.controller.learnmore(suffix);
      }
    });

    router.route("/" + ROUTES.CONTACT + "(/*suffix)", function (suffix, params) {
      log("route: /contact", suffix);
      if (!me.skipRoute) {
        App.controller.contact(suffix);
      }
    });

    router.route("/", (params) => {
      log("route: /", params);

      if (!me.skipRoute) {
        App.controller.home(params);
      }
    });

    //globbing
    router.route("/*suffix", function (suffix, params) {
      log("route: /*suffix=", suffix);
      if (!me.skipRoute) {
        App.controller.dynamic(suffix);
      }
    });


    let handleRouteParams = function (args) {
      //log('checkForRouteParams > ',args);
      let params = args;
      // Calling the preventDefault method of the event object will stop the change and restore the previous URL.
      //preventRoute = (args && typeof args.preventDefault === "function") ? args.preventDefault : function() {info("no preventDefault");return false;};

      if (args && args.params) {
        //log("checkForRouteParams > this is an evt",args); 
        params = args.params;
      }
      if (params && typeof params.share !== "undefined") {
        info("checkForRouteParams > ", params.share);

        switch (params.share) {
          case ROUTES.PLANT:
            ///plant(/:id)(/:name)(/*suffix)
            if (params.id) {

              if (!params.name) {
                params.name = "";
              }
              router.replace("/" + params.share + "/" + params.id + "/" + params.name);
              return true;
            }
            break;
          case ROUTES.PLANTS:
            ///plants(/*suffix)
            info("plants", params);
            if (params.loc) {

              console.error("now what?");
              //router.replace("/" + params.share + "/" + params.id + "/" + params.name);
            }
            break;
          case ROUTES.TIPS:
            ///tips(/*suffix)
            info("tips", params);
            if (params.loc) {

              console.error("now what?");
              //router.replace("/" + params.share + "/" + params.id + "/" + params.name);
            }
            break;
          case ROUTES.LEARN:
            ///tips(/*suffix)
            info("learnmore", params);
            if (params.loc) {

              console.error("now what?");
              //router.replace("/" + params.share + "/" + params.id + "/" + params.name);
            }
            break;
          case ROUTES.IDEAS:
            ///ideas(/*suffix)
            info("ideas", params);
            if (params.loc) {
              router.replace("/" + params.share + "/" + params.loc);
              return true;
            }
            break;
          case ROUTES.TRIVIA:
            ///trivia(/*suffix)
            info("trivia", params);
            if (params.loc) {

              console.error("now what?");
              //router.replace("/" + params.share + "/" + params.id + "/" + params.name);
            }
            break;
          case ROUTES.RESOURCES:
            ///resources(/*suffix)
            info("resources", params);
            if (params.loc) {

              console.error("now what?");
              //router.replace("/" + params.share + "/" + params.id + "/" + params.name);
            }
            break;
          case ROUTES.ABOUT:
            ///about(/*suffix)
            info("about", params);
            if (params.loc) {

              console.error("now what?");
              //router.replace("/" + params.share + "/" + params.id + "/" + params.name);
            }
            break;
          case ROUTES.CONTACT:
            ///contact(/*suffix)
            info("contact", params);
            if (params.loc) {

              console.error("now what?");
              //router.replace("/" + params.share + "/" + params.id + "/" + params.name);
            }
            break;
          case ROUTES.HOME:
            ///contact(/*suffix)
            info("index", params);
            if (params.loc) {

              console.error("now what?");
              //router.replace("/" + params.share + "/" + params.id + "/" + params.name);
            }
            break;
        }
      }

      return false;
    };


    // router.route("/items/:category/:id", function(category, id) {
    //     log(category, "item with", id, " was requested");
    // });
    // //optional segments
    // router.route("/items(/:category)(/:id)", function(category, id) {
    //     log(category, "item with", id, " was requested");
    // });
    // //globbing
    // router.route("/items/*suffix", function(suffix) {
    //     log(suffix);
    // });

    return router;
  }

} 
